import { getPendingGetCart } from '../../../shopcart/store/shopcart.selectors';

import { PendingCartItem } from '@api/cart/cart.models';
import { Category } from '@core/domain/models/category.models';
import { getCategory } from '@pages/category/public_api';
import { getLookbookPageCategory } from '@pages/lookbook/store/lookbook.selector';
import { MenuCategory } from '@shared/header/models/category.model';

export const categorySelectorConditions = {
    selector: getCategory,
    valuesNeeded: (category: Category) => {
        if (!category?.id) {
            return true;
        }
        return false;
    },
};

export const lookbookCategorySelectorConditions = {
    selector: getLookbookPageCategory,
    valuesNeeded: (category: MenuCategory) => {
        if (!category?.id) {
            return true;
        }
        return false;
    },
};

export const pendingGetCartSelectorConditions = {
    selector: getPendingGetCart,
    valuesNeeded: (pendingItems: PendingCartItem[]) => {
        if (pendingItems.length) {
            return true;
        }
        return false;
    },
};
